const DEBUG = 0
const INFO = 1
const WARN = 2
const ERROR = 3
const FATAL = 4
const UNKNOWN = 5

let logLevel = __LOG_LEVEL__
const NAME = 'PurchEase SDK : '

const arrayFromArgs = function arrayFromArgs (args) { return Array.prototype.slice.call(args) }

const consolePolyfilled = console || {}

if (!consolePolyfilled.debug || typeof consolePolyfilled.debug !== 'function') {
  consolePolyfilled.debug = function debug () {
    console.log.apply(this, ['[DEBUG]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.info || typeof consolePolyfilled.info !== 'function') {
  consolePolyfilled.info = function info () {
    console.log.apply(this, ['[INFO]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.warn || typeof consolePolyfilled.warn !== 'function') {
  consolePolyfilled.warn = function warn () {
    console.log.apply(this, ['[WARN]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.error || typeof consolePolyfilled.error !== 'function') {
  consolePolyfilled.error = function error () {
    console.log.apply(this, ['[ERROR]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.fatal || typeof consolePolyfilled.fatal !== 'function') {
  consolePolyfilled.fatal = function fatal () {
    console.log.apply(this, ['[FATAL]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.unknown || typeof consolePolyfilled.unknown !== 'function') {
  consolePolyfilled.unknown = function unknown () {
    console.log.apply(this, ['[UNKNOWN]'].concat(arrayFromArgs(arguments)))
  }
}

const Logger = {
  _setLogLevel (level) {
    logLevel = level
  },
  _apply (func, args) {
    func.apply(console, [NAME].concat(arrayFromArgs(args)))
  },
  debug () {
    if (logLevel <= DEBUG) {
      this._apply(consolePolyfilled.debug, arguments)
    }
  },
  info () {
    if (logLevel <= INFO) {
      this._apply(consolePolyfilled.info, arguments)
    }
  },
  warn () {
    if (logLevel <= WARN) {
      this._apply(consolePolyfilled.warn, arguments)
    }
  },
  error () {
    if (logLevel <= ERROR) {
      this._apply(consolePolyfilled.error, arguments)
    }
  },
  fatal () {
    if (logLevel <= FATAL) {
      this._apply(consolePolyfilled.fatal, arguments)
    }
  },
  unknown () {
    if (logLevel <= UNKNOWN) {
      this._apply(consolePolyfilled.unknown, arguments)
    }
  },
  log () {
    this._apply(consolePolyfilled.log, arguments)
  },
}
export default Logger



// WEBPACK FOOTER //
// ./src/initializers/Logger.js